import {getLocalizationBasedOnLang} from '../../../data/models/User/UserInfo';

const english = {
  carouselSlide1:
    'Measure knowledge retention through <mark>assessment-based</mark> video learning',
  carouselSlide2: '<mark>Sophisticated AI</mark> to support content generation',
  carouselSlide3:
    'Intuitive workflow-based editor - <mark>built with interactivity at its core</mark>',
  carouselSlide4:
    '<mark>Personalized</mark> learning journeys to master every outcome',
  carouselSlide5: 'Track learner progress <mark>in real-time</mark>',
  carouselSlide6:
    '<mark>Scalable</mark> and <mark>customizable</mark> for teams of any size',
};
const welsh = {
  carouselSlide1:
    'Mesurwch gadw gwybodaeth trwy ddysgu fideo <mark>seiliedig ar asesiad</mark>',
  carouselSlide2: '<mark>AI Sophistigedig</mark> i gefnogi cynhyrchu cynnwys',
  carouselSlide3:
    'Golygydd seiliedig ar weithffrwd - <mark>wedi ei adeiladu gyda rhyngweithiad yn ei graidd</mark>',
  carouselSlide4: 'Taith dysgu <mark>Personol</mark> i feistroli pob canlyniad',
  carouselSlide5: 'Olrhain cynnydd dysgwyr <mark>mewn amser real</mark>',
  carouselSlide6:
    '<mark>Ysgogadwy</mark> ac <mark>addasadwy</mark> ar gyfer timau o unrhyw faint',
};

export const AuthRoot2Text: any = getLocalizationBasedOnLang(english, welsh);
